module.exports = __webpack_public_path__ + "static/media/Prevent Default - The future of authoring tools (FT2017).45328f75.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/Prevent Default - The future of authoring tools (FT2017).pdf
// module id = 290
// module chunks = 0